import { Fragment } from "react";
import Menu from "../menu/Menu";
import InfoDisclaimer from "../disclaimer/InfoDisclaimer";
function Disclaimer() {
  return (
    <Fragment>
      <Menu />
      <InfoDisclaimer />
    </Fragment>
  );
}
export default Disclaimer;